import { XMarkIcon } from '@heroicons/react/24/solid';
import * as RadixToast from '@radix-ui/react-toast';
import { useEffect, useImperativeHandle, useState } from 'react';

import { HeroIcon } from '@/components/atoms';

interface ToastMetadata {
  title?: string;
  message: string;
}

export interface ToastImperativeHandle {
  open: (metadata: ToastMetadata) => void;
}

type VariantType = 'error';

interface ToastProps extends Pick<HTMLLIElement, 'className'> {
  ref?: React.Ref<ToastImperativeHandle>;
  variant?: VariantType;
  offsetX?: number;
  offsetY?: number;
}

const Toast = ({ ref, className, offsetX = 0, offsetY = 0 }: ToastProps) => {
  const [open, setOpen] = useState(false);
  const [meta, setMeta] = useState<ToastMetadata>();

  useImperativeHandle(ref, () => ({
    open: metadata => {
      setOpen(false);
      setMeta(metadata);
    },
  }));

  useEffect(() => {
    if (!meta) return;
    setOpen(true);
  }, [meta]);

  return (
    <RadixToast.Root
      className={`${className} flex flex-row gap-4 bg-surface-semantic-error text-(--color-text-primary-inverted) text-sm rounded-sm p-4`}
      style={{ margin: `${offsetY + 10}px ${offsetX + 10}px` }}
      open={open}
      onOpenChange={setOpen}
    >
      <div>
        {meta?.title && (
          <RadixToast.Title className="font-bold">
            {meta?.title}
          </RadixToast.Title>
        )}
        <RadixToast.Description>{meta?.message}</RadixToast.Description>
      </div>
      <RadixToast.Close className="cursor-pointer hover:scale-105 active:scale-95 transition-all duration-200 ease-in-out">
        <HeroIcon icon={XMarkIcon} />
      </RadixToast.Close>
    </RadixToast.Root>
  );
};

export { Toast };
